import { TableColumnsType } from 'antd';
import { DataTypeReportICTServices } from 'store/ducks/Reportings/types';

export const columns: TableColumnsType<DataTypeReportICTServices> = [
  {
    title: 'Name of the financial entity',
    width: 100,
    dataIndex: 'entity_name',
    key: 'entity_name',
    fixed: 'left',
  },
  {
    title: 'ICT service description',
    width: 100,
    dataIndex: 'ict_service_description',
    key: 'ict_service_description',
  },
  {
    title: 'ICT Services Valid from',
    width: 100,
    dataIndex: 'start_date',
    key: 'start_date',
  },
  {
    title: 'ICT Services Valid to',
    width: 100,
    dataIndex: 'end_date',
    key: 'end_date',
  },
  {
    title: 'Contractual arrangement',
    width: 100,
    dataIndex: 'contractual_arrangement',
    key: 'contractual_arrangement',
  },
  {
    title: 'Function name',
    width: 100,
    dataIndex: 'function_name',
    key: 'function_name',
  },
  {
    title: 'ICT service level',
    width: 100,
    dataIndex: 'ict_service_level',
    key: 'ict_service_level',
  },
  {
    title: 'ICT service type',
    width: 100,
    dataIndex: 'ict_service_type',
    key: 'ict_service_type',
  },
  {
    title: 'ICT services criticality',
    width: 100,
    dataIndex: 'ict_services_criticality',
    key: 'ict_services_criticality',
  },
  {
    title: 'Impact of discontinuing ICT services',
    width: 100,
    dataIndex: 'impact_of_discontinuing_ict_services',
    key: 'impact_of_discontinuing_ict_services',
  },
  {
    title: 'Storage of data',
    width: 100,
    dataIndex: 'storage_of_data',
    key: 'storage_of_data',
  },
];
export const columnsIctServicesDetails: TableColumnsType<DataTypeReportICTServices> =
  [
    {
      title: 'Name of the financial entity',
      width: 100,
      dataIndex: 'entity_name',
      key: 'entity_name',
      fixed: 'left',
    },
    {
      title: 'ICT service description',
      width: 100,
      dataIndex: 'ict_service_description',
      key: 'ict_service_description',
    },
    {
      title: 'Country',
      width: 100,
      dataIndex: 'country',
      key: 'country',
    },
    {
      title: 'Exit plan exists',
      width: 100,
      dataIndex: 'exit_plan_exists',
      key: 'exit_plan_exists',
    },
    {
      title: 'Impact of discontinuing function',
      width: 100,
      dataIndex: 'impact_of_discontinuing_function',
      key: 'impact_of_discontinuing_function',
    },
    {
      title: 'level of supporting ICT services',
      width: 100,
      dataIndex: 'level_of_supporting_ict_service',
      key: 'level_of_supporting_ict_service',
    },
    {
      title: 'possibility of reintegration',
      width: 100,
      dataIndex: 'possibility_of_reintegration',
      key: 'possibility_of_reintegration',
    },
    {
      title: 'Substitutability of ICT provider',
      width: 100,
      dataIndex: 'substitutability_of_ict_provider',
      key: 'substitutability_of_ict_provider',
    },
    {
      title: 'Third party service provider name',
      width: 100,
      dataIndex: 'third_party_service_provider_name',
      key: 'third_party_service_provider_name',
    },
    {
      title: 'TPP code type',
      width: 100,
      dataIndex: 'tpp_code_type',
      key: 'tpp_code_type',
    },
    {
      title: 'Selected Date',
      width: 100,
      dataIndex: 'date',
      key: 'date',
    },
  ];
